module.exports = __webpack_public_path__ + "img/Group 1.31bd9e71.png";